export default __webpack_public_path__ + "static/media/fw-olivia-er-Rose Gold.8d13ff4b.mp4";